import i18next from 'i18next';
import { DateTime } from 'luxon';

export const dateStatusMapping = (d: DateTime): string => {
  const dayOffset = d.startOf('day').diff(DateTime.now().startOf('day'), 'days').days;

  if (dayOffset === 0) return i18next.t('ticket-details.ticket-conversation.date.today');
  if (dayOffset === -1) return i18next.t('ticket-details.ticket-conversation.date.yesterday');

  return d.setLocale(i18next.language).toLocaleString(DateTime.DATE_HUGE);
};

export interface ActivityDayGroup<T> {
  key: string;
  label: string;
  items: T[];
}

const UNDATED_KEY = '9999-12-31';

export const groupActivitiesByDay = <T extends { ModifiedDate?: string }>(
  activities: T[]
): ActivityDayGroup<T>[] => {
  const groups = new Map<string, ActivityDayGroup<T>>();

  activities.forEach(activity => {
    const d = DateTime.fromJSDate(new Date(activity.ModifiedDate));
    const key = d.isValid ? d.toISODate() : UNDATED_KEY;

    if (!groups.has(key)) {
      groups.set(key, { key, label: d.isValid ? dateStatusMapping(d) : '', items: [] });
    }
    groups.get(key).items.push(activity);
  });

  return [...groups.values()].sort((a, b) => a.key.localeCompare(b.key));
};
